<template>
  <b-modal
    id="advance-fund-confirm"
    title="ยืนยันการอนุมัติงบสำรองจ่าย"
    ok-title="ยืนยัน"
    ok-variant="primary"
    cancel-title="ยกเลิก"
    @ok="submit"
    @hidden="reset"
  >
    <p class="text-center">กรอกยอดงบสำรองจ่ายที่อนุมัติ</p>
    <table class="table table-bordered mb-0">
      <tbody>
        <tr>
          <td class="align-middle">
            <strong>ยอดงบสำรองจ่ายที่ขออนุมัติ</strong>
          </td>
          <td class="align-middle">
            {{ requestedAmount | numeral('0,0.00') }} บาท
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ยอดที่อนุมัติ</strong>
          </td>
          <td class="align-middle">
            <b-input-group append="บาท">
              <b-form-input v-model.number="approvedAdvanceFund" type="number" />
            </b-input-group>
          </td>
        </tr>
      </tbody>
    </table>
  </b-modal>
</template>

<script>
export default {
  props: {
    requestedAmount: { type: Number, default: 0 }
  },
  data: () => ({
    approvedAdvanceFund: 0
  }),
  methods: {
    async submit () {
      await this.$store.dispatch('project/approveAdvanceFund', {
        id: this.$route.params.id,
        amount: this.approvedAdvanceFund
      })

      this.$bvToast.toast('อนุมัติงบสำรองจ่ายสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
    },
    reset () {
      this.approvedAdvanceFund = 0
      this.$emit('closed')
    }
  }
}
</script>
